import actions from './actions';

const initState = {
    pillverySelect   : {},
    loading : false,
    errorMessage: null
};

export default function createOrUpdateSelectReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_SELECT_REQUESTED:
            return {
                ...state,
                pillverySelect   : {},
                loading : true
            };
        case actions.CREATE_OR_UPDATE_SELECT_SUCCEEDED:

            return {
                ...state,
                pillverySelect   : action.pillverySelect,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_SELECT_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error
            };
        default:
            return state;
    }
}
